import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  disabled: boolean;
  onClickUrl: string;
  style?: React.CSSProperties;
};

export const CustomLink: React.FC<Props> = ({ disabled, onClickUrl, children, style }) => {
  return (
    <span style={{ width: 'inherit' }} className={disabled ? 'disabled-wrap' : ''}>
      <Link style={{ width: 'inherit', ...style }} to={onClickUrl} className={disabled ? 'disabled-link' : ''}>
        {children}
      </Link>
    </span>
  );
};
